import { Component } from 'react';

import type { ReactNode } from 'react';

interface ErrorBoundaryProps {
  readonly children: ReactNode;
}

interface ErrorBoundaryState {
  readonly message: string | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { message: null };

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { message: error instanceof Error ? error.message : 'Something went wrong.' };
  }

  override render(): ReactNode {
    const { message } = this.state;

    if (message === null) return this.props.children;

    return (
      <div className="grid min-h-dvh place-items-center bg-mist px-6 dark:bg-dark-board">
        <div className="w-full max-w-[420px] rounded-card border border-hairline bg-white p-6 text-center shadow-menu dark:border-dark-line dark:bg-dark-panel">
          <h1 className="font-display text-[22px] font-extrabold tracking-[-0.02em] text-navy dark:text-dark-ink">
            Something broke on this screen
          </h1>
          <p className="mt-2 text-[14px] leading-relaxed text-navy/75 dark:text-dark-ink/75">
            Nothing you were working on was lost — the last change you made was already sent.
            Reloading usually clears it.
          </p>

          <p className="mt-4 rounded-panel bg-mist px-3 py-2 text-left text-[12.5px] break-words text-muted dark:bg-dark-field">
            {message}
          </p>

          <button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
            className="mt-5 inline-flex min-h-[40px] items-center justify-center rounded-field bg-gold px-4 text-[14px] font-bold text-navy shadow-gold transition hover:brightness-[1.03]"
          >
            Reload the page
          </button>
        </div>
      </div>
    );
  }
}
